// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mode-selection-main {
  padding-top: 4.375rem;
  height: 100vh;
  min-height: 100vh;
  background-color: var(--primary-bg-color);
}
/* .mode-selection-main .inner-wrapper {
  margin-top: 2rem !important;
} */
.mode-selection-main .inner-wrapper .left {
  margin-top: 3rem;
  margin-left: 2rem;
}
.mode-selection-main .inner-wrapper .left h1 {
  color: white !important;
  font-size: 3rem;
  margin: 0 !important;
}
.mode-selection-main .inner-wrapper .left p {
  color: white;
}
.mode-selection-main .inner-wrapper .left img {
  width: 12rem;
  margin-top: 2rem;
}
@media only screen and (max-width: 36.063rem) {
  .mode-selection-main {
    height: 100%;
    padding-top: 0;
  }
}
@media only screen and (max-width: 81.25rem) {
  .mode-selection-main .background {
    display: none;
  }
}

.mode-selection-main .inner-wrapper {
  margin: auto;
  width: 90%;
  background-color: var(--primary-bg-color);
}
@media only screen and (max-height: 37.5rem) {
  .mode-selection-main .inner-wrapper {
    width: 100%;
  }
}
.mode-selection-main .inner-wrapper .left .title {
  max-width: 31.875rem;
}

.mode-selection-main .inner-wrapper .left .sub-title {
  font-size: 0.875rem;
  margin-top: 0;
  max-width: 21.25rem;
}
@media only screen and (max-width: 760.313rem) {
  .mode-selection-main .inner-wrapper .left .title {
    max-width: 100%;
  }

  .mode-selection-main .inner-wrapper .left .subtitle {
    max-width: 100%;
  }
}

.mode-selection-main .inner-wrapper .right img {
  width: 100%;
  height: auto;
}

@media only screen and (max-width: 760.313rem) {
  .mode-selection-main .inner-wrapper .right {
    text-align: center;
  }
  .mode-selection-main .inner-wrapper .right img {
    width: 80%;
    margin: auto;
  }
}
.mode-selection-main .inner-wrapper .list-wrapper {
  list-style-type: none;
  padding: 0 !important;
}
.mode-selection-main .inner-wrapper .list-wrapper .item {
  /* max-width: 13.125rem; */
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
@media only screen and (max-width: 36.063rem) {
  .mode-selection-main .inner-wrapper .list-wrapper .item {
    margin: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/ModeSelection.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,aAAa;EACb,iBAAiB;EACjB,yCAAyC;AAC3C;AACA;;GAEG;AACH;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE;IACE,YAAY;IACZ,cAAc;EAChB;AACF;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yCAAyC;AAC3C;AACA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,UAAU;IACV,YAAY;EACd;AACF;AACA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".mode-selection-main {\n  padding-top: 4.375rem;\n  height: 100vh;\n  min-height: 100vh;\n  background-color: var(--primary-bg-color);\n}\n/* .mode-selection-main .inner-wrapper {\n  margin-top: 2rem !important;\n} */\n.mode-selection-main .inner-wrapper .left {\n  margin-top: 3rem;\n  margin-left: 2rem;\n}\n.mode-selection-main .inner-wrapper .left h1 {\n  color: white !important;\n  font-size: 3rem;\n  margin: 0 !important;\n}\n.mode-selection-main .inner-wrapper .left p {\n  color: white;\n}\n.mode-selection-main .inner-wrapper .left img {\n  width: 12rem;\n  margin-top: 2rem;\n}\n@media only screen and (max-width: 36.063rem) {\n  .mode-selection-main {\n    height: 100%;\n    padding-top: 0;\n  }\n}\n@media only screen and (max-width: 81.25rem) {\n  .mode-selection-main .background {\n    display: none;\n  }\n}\n\n.mode-selection-main .inner-wrapper {\n  margin: auto;\n  width: 90%;\n  background-color: var(--primary-bg-color);\n}\n@media only screen and (max-height: 37.5rem) {\n  .mode-selection-main .inner-wrapper {\n    width: 100%;\n  }\n}\n.mode-selection-main .inner-wrapper .left .title {\n  max-width: 31.875rem;\n}\n\n.mode-selection-main .inner-wrapper .left .sub-title {\n  font-size: 0.875rem;\n  margin-top: 0;\n  max-width: 21.25rem;\n}\n@media only screen and (max-width: 760.313rem) {\n  .mode-selection-main .inner-wrapper .left .title {\n    max-width: 100%;\n  }\n\n  .mode-selection-main .inner-wrapper .left .subtitle {\n    max-width: 100%;\n  }\n}\n\n.mode-selection-main .inner-wrapper .right img {\n  width: 100%;\n  height: auto;\n}\n\n@media only screen and (max-width: 760.313rem) {\n  .mode-selection-main .inner-wrapper .right {\n    text-align: center;\n  }\n  .mode-selection-main .inner-wrapper .right img {\n    width: 80%;\n    margin: auto;\n  }\n}\n.mode-selection-main .inner-wrapper .list-wrapper {\n  list-style-type: none;\n  padding: 0 !important;\n}\n.mode-selection-main .inner-wrapper .list-wrapper .item {\n  /* max-width: 13.125rem; */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n@media only screen and (max-width: 36.063rem) {\n  .mode-selection-main .inner-wrapper .list-wrapper .item {\n    margin: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
